export default "__VITE_ASSET__BFTXrblz__"